"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.834 0c.918 0 1.7.602 1.97 1.433l.044.158h1.366c.765 0 1.395.586 1.467 1.333l.007.141v.117h1.907c1.093 0 1.99.85 2.066 1.924l.006.147v1.591a.48.48 0 0 1-.953.087l-.007-.087v-1.59c0-.573-.435-1.045-.991-1.105l-.121-.007h-1.907v1.111a.48.48 0 0 1-.394.472l-.086.007h-8.75a.479.479 0 0 1-.473-.392l-.007-.087v-1.11H2.072c-.573 0-1.045.433-1.106.99l-.006.12V21.96c0 .572.434 1.044.99 1.105l.122.006h13.523c.572 0 1.045-.434 1.105-.99l.007-.12v-3.978a.48.48 0 0 1 .952-.086l.008.086v3.977c0 1.093-.85 1.99-1.925 2.065l-.147.005H2.072a2.072 2.072 0 0 1-2.066-1.922L0 21.96V5.253c0-1.092.849-1.99 1.923-2.065l.148-.006h1.906v-.117c0-.765.585-1.395 1.333-1.467l.142-.007h1.366A2.073 2.073 0 0 1 8.834.001Zm10.98 6.29a2.485 2.485 0 0 1 3.502.07c.871.92.91 2.324.12 3.277l-.12.133-9.148 9.156a.454.454 0 0 1-.155.104l-.09.027-3.517.7a.48.48 0 0 1-.574-.47l.01-.095.7-3.516a.48.48 0 0 1 .072-.173l.058-.073 9.142-9.14Zm-8.384 9.841-.506 2.543 2.526-.502a2.438 2.438 0 0 0-.58-1.175l-.132-.136a2.455 2.455 0 0 0-1.126-.685l-.182-.045Zm6.616-6.715-5.922 5.921a3.43 3.43 0 0 1 1.133.688l.159.157c.322.301.574.677.752 1.092l.084.21 5.928-5.933-2.134-2.135Zm4.576-2.393a1.522 1.522 0 0 0-2.02-.146l-.117.1-1.76 1.76 2.133 2.134 1.773-1.773a1.505 1.505 0 0 0-.01-2.075ZM8.834.96c-.553 0-1.013.405-1.098.935a.48.48 0 0 1-.36.648l-.086.008H5.453a.515.515 0 0 0-.507.422l-.008.092v1.708h7.79V3.065a.515.515 0 0 0-.422-.505l-.092-.009h-1.79a.48.48 0 0 1-.48-.48 1.11 1.11 0 0 0-1.11-1.11Z",
    clipRule: "evenodd"
  })]
});